'use client';

import { useCallback, useEffect, useRef } from 'react';

export function useHoverCloseTimeout(delayMs: number, onClose: () => void) {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const cancel = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    const schedule = useCallback(() => {
        cancel();
        timeoutRef.current = setTimeout(onClose, delayMs);
    }, [cancel, onClose, delayMs]);

    useEffect(() => cancel, [cancel]);

    return { schedule, cancel };
}
